import { ChangeEvent, FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Checkbox, Stack, Typography } from '@thirdspacelearning/library';

interface Props extends FieldRenderProps<boolean> {
    label: string;
}

const sx = {
    fieldRow: {
        alignItems: 'center',
    },
    labelText: {
        fontWeight: 'SemiBold',
    },
};

const CheckboxFinalField: FC<Props> = ({
    label,
    input,
    meta: _meta,
    ...rest
}) => {
    const { checked, onChange } = input;

    return (
        <Stack direction="row" spacing={1} sx={sx.fieldRow}>
            <Checkbox
                {...rest}
                checked={checked}
                color="primary"
                onChange={(event: ChangeEvent<HTMLInputElement>) =>
                    onChange(event)
                }
                disableRipple
                size="small"
                variant="modern"
                slotProps={{
                    input: {
                        'aria-labelledby': 'checkbox',
                    },
                }}
            />
            <Typography variant="body2" sx={sx.labelText}>
                {label}
            </Typography>
        </Stack>
    );
};

export default CheckboxFinalField;
